import React, { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import PetalsCanvas from "@/components/PetalsCanvas";
import WhatsAppFab from "@/components/WhatsAppFab";
import Marquee from "@/components/Marquee";
import Hero from "@/sections/Hero";
import Promo from "@/sections/Promo";
import Products from "@/sections/Products";
import Gallery from "@/sections/Gallery";
import Process from "@/sections/Process";
import Footer from "@/sections/Footer";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-sakura-100 p-8 text-center">
                    <div>
                        <p className="font-display text-3xl text-sakura-900">
                            Something wilted — please refresh the page.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
            return;
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <div className="grain relative min-h-screen bg-sakura-100 font-body text-sakura-900">
                    <PetalsCanvas className="pointer-events-none fixed inset-0 z-[5] h-full w-full" />
                    <Navbar />
                    <main className="relative z-10">
                        <Hero />
                        <Marquee />
                        <Promo />
                        <Products />
                        <Gallery />
                        <Process />
                        <Footer />
                    </main>
                    <WhatsAppFab />
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
